import Vue from 'vue'
import App from '@/App.vue'
import Router from '@/router'
import Store from '@/store'

import Vuetify from '@/plugins/Vuetify'
import Notification from '@/services/notification'
import VueI18n from '@/plugins/VueI18n'

import '@/assets/scss/style.scss'

import '@/plugins/Alert'
import '@/plugins/Dayjs'
import '@/plugins/Filter'
import '@/plugins/Keypress'
import '@/plugins/OnInputValue'
import '@/plugins/Validation'
import '@/plugins/MapMenu'
import '@/plugins/Socket'

Vue.config.productionTip = false
Vue.config.devtools = process.env.NODE_ENV !== 'production'
Vue.prototype.$notify = new Notification()

new Vue({
  router: Router,
  store: Store,
  vuetify: Vuetify,
  i18n: VueI18n,
  render: (h) => h(App)
}).$mount('#app')
